import { Usuario } from './../../_core/models/usuario';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from './../../_core/services/authentication/authentication.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { SideMenuService } from 'src/app/_core/services/sidemenu.service';
import { Component, OnInit } from '@angular/core';
import { filter, map, mergeMap } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  title = 'Principal';
  usuarioLogado!: string;
  user:any;
  constructor(
    public sideMenuService: SideMenuService,
    private router: Router,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private modalService: NgbModal
  ) {
    this.authenticationService.currentUser.subscribe((data) => {
      if (data != null) {
        if (data.dS_LOGIN_USUARIO != null) {
          this.usuarioLogado = data.nome;
        }
      }
    });
  }

  ngOnInit(): void {
   this.user = JSON.parse(localStorage.getItem('currentUser')!);
    this.router.events
    .pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.route),
      map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }),
      filter((route) => route.outlet === 'primary'),
      mergeMap((route) => route.data)
    )
    .subscribe((data) => {
      this.title = data.title;
    });
  }
  
  logout(): void {
    this.authenticationService.logout();
  }
}
